(function(){
'use strict';
if(window.__elcExpressV2ThemeLoaded)return;
window.__elcExpressV2ThemeLoaded=true;
var core=window.ExpressDeliveryCore;
if(!core){console.error('Express Delivery V2: core unavailable');return;}
var STORAGE='elc_express_v2_location';
var FILTER='elc_express_v2_filter';
var CACHE='elc_express_v2_cache_';
var config=null;
var pending=null;
var inventorySeq=0;
var lastFocus=null;
var promiseTimer=null;

function readConfig(){
  if(config)return config;
  var el=document.getElementById('express-delivery-v2-config');
  if(!el)return null;
  try{
    var raw=JSON.parse(el.textContent||'{}');
    var radius=Number(raw.radiusKm||10);
    raw.stores=(raw.stores||[]).map(function(store,index){
      return Object.assign({},store,{active:store.active!==false,radiusKm:radius,priority:index});
    });
    raw.stores=core.normalizeStores(raw.stores);
    config=raw;
    return config;
  }catch(error){console.error('Express Delivery V2: invalid config',error);return null;}
}
function tokenReady(){var c=readConfig();return !!String(c&&c.storefrontToken||'').trim();}
function esc(value){return String(value==null?'':value).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];});}
function readLocation(){
  try{
    var value=JSON.parse(sessionStorage.getItem(STORAGE)||'null');
    if(!value||!Number.isFinite(Number(value.lat))||!Number.isFinite(Number(value.lng)))return null;
    return {lat:Number(value.lat),lng:Number(value.lng),label:String(value.label||'Selected area'),area:String(value.area||'').trim(),source:value.source||'area'};
  }catch(_e){return null;}
}
function saveLocation(location){
  sessionStorage.setItem(STORAGE,JSON.stringify({lat:Number(location.lat),lng:Number(location.lng),label:String(location.label||'Selected area'),area:String(location.area||'').trim(),source:location.source||'area'}));
}
function displayArea(location){
  if(!location)return '';
  var area=String(location.area||'').trim();
  if(area&&!/^(current location|finding your area|pinned map location)$/i.test(area))return area;
  var label=String(location.label||'').trim();
  if(!label||/^(current location|finding your area)/i.test(label))return 'Finding your area…';
  return label;
}
function eligibleStores(location){return core.findEligibleStores(location,(readConfig()&&readConfig().stores)||[]);}
function formatDate(value){
  var iso=String(value||'');
  if(!/^\d{4}-\d{2}-\d{2}$/.test(iso))return iso;
  var date=new Date(iso+'T12:00:00+04:00');
  if(!Number.isFinite(date.getTime()))return iso;
  return new Intl.DateTimeFormat('en-AE',{day:'numeric',month:'short',weekday:'short',timeZone:'Asia/Dubai'}).format(date);
}
function formatCutoff(){
  var c=readConfig()||{};
  var hour=Number(c.cutoffHour);
  var minute=Number(c.cutoffMinute);
  if(!Number.isFinite(hour))hour=16;
  if(!Number.isFinite(minute))minute=0;
  hour=Math.min(23,Math.max(0,Math.floor(hour)));
  minute=Math.min(59,Math.max(0,Math.floor(minute)));
  return String(hour%12||12)+':'+String(minute).padStart(2,'0')+(hour<12?' AM':' PM');
}
function schedulePromiseRefresh(){
  if(promiseTimer!==null)window.clearTimeout(promiseTimer);
  var c=readConfig()||{};
  var hour=Number(c.cutoffHour);
  var minute=Number(c.cutoffMinute);
  if(!Number.isFinite(hour))hour=16;
  if(!Number.isFinite(minute))minute=0;
  hour=Math.min(23,Math.max(0,Math.floor(hour)));
  minute=Math.min(59,Math.max(0,Math.floor(minute)));
  var dubaiNow=new Date(Date.now()+4*60*60*1000);
  var elapsed=((dubaiNow.getUTCHours()*60+dubaiNow.getUTCMinutes())*60+dubaiNow.getUTCSeconds())*1000+dubaiNow.getUTCMilliseconds();
  var cutoff=((hour*60)+minute)*60000;
  var cutoffWait=cutoff>elapsed?cutoff-elapsed:Infinity;
  var standard=(c.standardDelivery||{});
  var standardHour=Number(standard.cutoffHour);
  if(!Number.isFinite(standardHour))standardHour=12;
  var standardMinute=Number(standard.cutoffMinute)||0;
  var standardCutoff=(standardHour*60+standardMinute)*60000;
  var standardCutoffWait=standardCutoff>elapsed?standardCutoff-elapsed:Infinity;
  var midnightWait=24*60*60*1000-elapsed;
  promiseTimer=window.setTimeout(function(){
    refreshAll();
    schedulePromiseRefresh();
  },Math.max(1000,Math.min(cutoffWait,standardCutoffWait,midnightWait)+1000));
}
function promise(){
  var c=readConfig()||{};
  return core.getDeliveryPromise({cutoffHour:Number(c.cutoffHour||16),cutoffMinute:Number(c.cutoffMinute||0),closedWeekdays:c.closedWeekdays||[0],closedDates:c.closedDates||'',timeZone:c.timeZone||'Asia/Dubai'});
}
function standardFor(variantId,quantity,stock,liquidFallback){
  var c=readConfig()||{};
  var settings=c.standardDelivery||{};
  if(settings.enabled===false)return null;
  var id=core.normalizeVariantGid(variantId);
  var inventory=stock&&stock[id]||{};
  var warehouseId=core.normalizeLocationGid(settings.warehouseLocationId||'gid://shopify/Location/71443218497');
  var warehouse=inventory[warehouseId];
  var remaining=Object.keys(inventory).filter(function(locationId){return locationId!==warehouseId;})
    .reduce(function(largest,locationId){return Math.max(largest,Math.max(0,Number(inventory[locationId].quantity)||0));},0);
  var verifiedWarehouse=Math.max(0,Number(warehouse&&warehouse.quantity)||0);
  if(verifiedWarehouse===0&&remaining===0&&liquidFallback&&liquidFallback.available===true&&liquidFallback.managed===true){
    var aggregate=Number(liquidFallback.totalQuantity);
    if(Number.isInteger(aggregate)&&aggregate>=Math.max(1,Number(quantity)||1)){
      remaining=aggregate;
    }
  }
  return core.getStandardDeliveryPromise({
    warehouseQuantity:warehouse?warehouse.quantity:0,
    otherQuantity:remaining,
    quantity:quantity,
    cutoffHour:Number(settings.cutoffHour===undefined?12:settings.cutoffHour),
    cutoffMinute:Number(settings.cutoffMinute||0),
    branchDays:Number(settings.branchDays||2),
    closedDates:settings.closedDates||c.closedDates||'',
    closedWeekdays:settings.closedWeekdays===undefined?[0,6]:settings.closedWeekdays,
    timeZone:c.timeZone||'Asia/Dubai'
  });
}
function fallbackFromCard(badge){
  return {
    available:badge.dataset.variantAvailable==='true',
    managed:badge.dataset.inventoryManaged==='true',
    totalQuantity:Number(badge.dataset.totalInventory)
  };
}
function fallbackFromPdp(variantId){
  var select=document.querySelector('[data-product-page] [data-variant-select]');
  var option=select&&select.selectedOptions?select.selectedOptions[0]:null;
  if(!option||core.normalizeVariantGid(option.value)!==core.normalizeVariantGid(variantId))return null;
  return {
    available:option.dataset.available==='true',
    managed:option.dataset.inventoryManaged==='true',
    totalQuantity:Number(option.dataset.inventory)
  };
}
function standardCardLabel(estimate){
  return estimate&&estimate.deliveryDate?formatDate(estimate.deliveryDate):'';
}
function emitStandard(variantId,stock,location,quantity){
  var estimate=standardFor(variantId,quantity||1,stock,fallbackFromPdp(variantId));
  var where=location?'Deliver to: '+displayArea(location):'Choose a delivery area for Express eligibility.';
  if(!estimate){
    bridge({variantId:variantId,state:'standard',title:'🚚 Estimated delivery',message:'Check delivery estimate at checkout.',detail:where,badge:'',actionLabel:location?'Change location':'Choose location'});
    return;
  }
  var fast=estimate.warehouseFast;
  var tomorrow=estimate.isTomorrow;
  var title=fast&&tomorrow?'🚚 Get it tomorrow':'🚚 Estimated delivery';
  var message=fast
    ?'Order before '+formatStandardCutoff()+' for delivery '+(tomorrow?'tomorrow.':'by '+formatDate(estimate.deliveryDate)+'.')
    :'Expected arrival: '+formatDate(estimate.deliveryDate)+'.';
  bridge({variantId:variantId,state:'standard',title:title,message:message,detail:where,badge:'',actionLabel:location?'Change location':'Choose location'});
}
function formatStandardCutoff(){
  var settings=(readConfig()||{}).standardDelivery||{};
  var hour=Number(settings.cutoffHour===undefined?12:settings.cutoffHour);
  var minute=Number(settings.cutoffMinute||0);
  if(!Number.isFinite(hour))hour=12;
  if(!Number.isFinite(minute))minute=0;
  hour=Math.max(0,Math.min(23,Math.floor(hour)));
  minute=Math.max(0,Math.min(59,Math.floor(minute)));
  return String(hour%12||12)+':'+String(minute).padStart(2,'0')+(hour<12?' AM':' PM');
}
function status(text,tone){
  var el=document.querySelector('[data-express-v2-status]');
  if(!el)return;
  el.textContent=text||'';
  el.dataset.tone=tone||'';
}
function updateLauncher(){
  var loc=readLocation();
  var label=displayArea(loc);
  document.querySelectorAll('[data-express-v2-launcher-label]').forEach(function(el){
    el.textContent='Check Express Delivery';
  });
  document.querySelectorAll('[data-express-v2-mobile-label]').forEach(function(el){
    el.textContent='Check Express';
  });
  var launcherButton=document.querySelector('.express-v2-launcher__button');
  if(launcherButton){
    var description=loc?'Change delivery location. Delivery area: '+label:'Choose an Express Delivery location';
    launcherButton.setAttribute('aria-label',description);
    launcherButton.title=description;
  }
}
function syncMobileLauncher(){
  var launcher=document.querySelector('[data-express-v2-launcher]');
  if(!launcher)return;
  var mobile=!!(window.matchMedia&&window.matchMedia('(max-width:749px)').matches);
  var currentPage=(readConfig()||{}).pageType;
  var productWithDelivery=currentPage==='product'&&!!document.querySelector('[data-express-delivery-slot]');
  launcher.hidden=productWithDelivery;
  if(productWithDelivery)return;
  var filter=mobile&&currentPage==='collection'?document.querySelector('[data-express-v2-filter]'):null;
  var parent=filter||document.body;
  if(parent&&launcher.parentNode!==parent)parent.appendChild(launcher);
}
function updateSelection(){
  var box=document.querySelector('[data-express-v2-selection]');
  var save=document.querySelector('[data-express-v2-save]');
  if(!box||!save)return;
  if(!pending){box.hidden=true;box.textContent='';save.disabled=true;return;}
  var stores=eligibleStores(pending);
  box.hidden=false;
  box.innerHTML='<strong>'+esc(pending.label)+'</strong><span>'+(stores.length?esc(stores[0].name)+' · '+stores[0].distanceKm.toFixed(1)+' km away':'Outside the current 10 km Express Delivery area')+'</span>';
  save.disabled=pending.source==='gps'&&/^(current location|finding your area)/i.test(String(pending.label||''));
}
function open(){
  var overlay=document.querySelector('[data-express-v2-overlay]');
  if(!overlay)return;
  lastFocus=document.activeElement;
  pending=readLocation();
  updateSelection();
  status('');
  overlay.hidden=false;
  document.documentElement.classList.add('express-v2-modal-open');
  document.dispatchEvent(new CustomEvent('express-v2:opened',{detail:{location:pending}}));
  var close=document.querySelector('[data-express-v2-close]');
  if(close)close.focus();
}
function close(){
  var overlay=document.querySelector('[data-express-v2-overlay]');
  if(!overlay)return;
  overlay.hidden=true;
  document.documentElement.classList.remove('express-v2-modal-open');
  if(lastFocus&&lastFocus.focus)lastFocus.focus();
}
function setPending(location){
  pending=location;
  updateSelection();
  document.dispatchEvent(new CustomEvent('express-v2:pending-changed',{detail:location}));
}
function populateAreas(){
  var select=document.querySelector('[data-express-v2-area]');
  if(!select||select.dataset.ready==='true')return;
  (readConfig().areas||[]).forEach(function(area,index){
    var option=document.createElement('option');
    option.value=String(index);option.textContent=area.name;select.appendChild(option);
  });
  select.dataset.ready='true';
}
function useLocation(){
  if(!navigator.geolocation){status('Location services are not supported on this device.','error');return;}
  status('Detecting your location…');
  navigator.geolocation.getCurrentPosition(function(pos){
    setPending({lat:pos.coords.latitude,lng:pos.coords.longitude,label:'Finding your area…',area:'',source:'gps'});
    status('Location detected. Identifying your area…');
  },function(){status('We could not access your location. Please choose an area instead.','error');},{enableHighAccuracy:true,timeout:10000,maximumAge:120000});
}
function chooseArea(event){
  var index=Number(event.target.value);
  if(!Number.isInteger(index)){setPending(null);return;}
  var area=(readConfig().areas||[])[index];
  if(area)setPending({lat:area.lat,lng:area.lng,label:area.name,source:'area'});
}
function commitLocation(){
  if(!pending||(pending.source==='gps'&&/^(current location|finding your area)/i.test(String(pending.label||''))))return;
  saveLocation(pending);updateLauncher();close();
  window.dispatchEvent(new CustomEvent('express-delivery:location-updated',{detail:pending}));
}
function bindUi(){
  updateLauncher();
  document.querySelectorAll('[data-express-v2-open]').forEach(function(btn){
    if(btn.dataset.expressBound)return;btn.dataset.expressBound='1';btn.addEventListener('click',open);
  });
  var closeBtn=document.querySelector('[data-express-v2-close]');
  if(closeBtn&&!closeBtn.dataset.expressBound){closeBtn.dataset.expressBound='1';closeBtn.addEventListener('click',close);}
  var overlay=document.querySelector('[data-express-v2-overlay]');
  if(overlay&&!overlay.dataset.expressBound){overlay.dataset.expressBound='1';overlay.addEventListener('click',function(e){if(e.target===overlay)close();});}
  var gps=document.querySelector('[data-express-v2-use-location]');
  if(gps&&!gps.dataset.expressBound){gps.dataset.expressBound='1';gps.addEventListener('click',useLocation);}
  var save=document.querySelector('[data-express-v2-save]');
  if(save&&!save.dataset.expressBound){save.dataset.expressBound='1';save.addEventListener('click',commitLocation);}
  if(!window.__elcExpressV2Escape){window.__elcExpressV2Escape=true;document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});}
}
function hash(value){var h=5381;for(var i=0;i<value.length;i+=1)h=(h*33)^value.charCodeAt(i);return (h>>>0).toString(36);}
function cacheKey(ids,loc){return Number(loc.lat).toFixed(3)+'|'+Number(loc.lng).toFixed(3)+'|'+ids.map(core.normalizeVariantGid).sort().join('|');}
function readCache(key){
  try{var value=JSON.parse(sessionStorage.getItem(CACHE+hash(key))||'null');if(value&&value.key===key&&Date.now()-value.at<120000)return value.data;}catch(_e){}
  return null;
}
function writeCache(key,data){try{sessionStorage.setItem(CACHE+hash(key),JSON.stringify({key:key,at:Date.now(),data:data}));}catch(_e){}}
async function queryInventory(ids,loc){
  if(!tokenReady())throw new Error('token_missing');
  var unique=Array.from(new Set(ids.map(core.normalizeVariantGid).filter(Boolean)));
  if(!unique.length)return {};
  var key=cacheKey(unique,loc);
  var cached=readCache(key);if(cached)return cached;
  var query='query ExpressDeliveryAvailability($ids: [ID!]!, $near: GeoCoordinateInput!) { nodes(ids: $ids) { ... on ProductVariant { id storeAvailability(first: 50, near: $near) { nodes { available quantityAvailable pickUpTime location { id name } } } } } }';
  var c=readConfig();
  var response=await fetch('/api/'+(c.apiVersion||'2026-07')+'/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':String(c.storefrontToken).trim()},body:JSON.stringify({query:query,variables:{ids:unique,near:{latitude:Number(loc.lat),longitude:Number(loc.lng)}}})});
  var payload=await response.json();
  if(!response.ok||(payload.errors&&payload.errors.length))throw new Error((payload.errors&&payload.errors[0]&&payload.errors[0].message)||'inventory_error');
  var indexed=core.indexAvailability({nodes:(payload.data&&payload.data.nodes)||[]});
  writeCache(key,indexed);return indexed;
}
function pill(badge,state,label){
  badge.dataset.deliveryState=state;
  if(state==='unavailable'){
    badge.innerHTML='';
    badge.hidden=true;
    return;
  }
  badge.hidden=false;
  if(state==='standard'){
    var date=String(label||'').trim();
    var text=date?'Estimated: '+date:'Check delivery estimate';
    var fullLabel=date?'Estimated delivery: '+date:text;
    badge.innerHTML='<span class="express-v2-pill express-v2-pill--estimate" data-state="standard" aria-label="'+esc(fullLabel)+'">'+
      '<span class="express-v2-pill__icon" aria-hidden="true">🚚</span>'+
      '<span class="express-v2-pill__text">'+esc(text)+'</span>'+
    '</span>';
    return;
  }
  badge.innerHTML='<button type="button" class="express-v2-pill" data-state="'+esc(state)+'"'+(state==='choose'?' data-express-v2-open':'')+'>'+esc(label)+'</button>';
}
function injectFilter(){
  var c=readConfig();if(!c||c.pageType!=='collection')return;
  if(document.querySelector('[data-express-v2-filter]'))return;
  if(!document.querySelector('[data-express-delivery-card-badge]'))return;
  var main=document.querySelector('#MainContent')||document.querySelector('main');if(!main)return;
  var wrap=document.createElement('div');wrap.className='express-v2-filter';wrap.setAttribute('data-express-v2-filter','');
  wrap.innerHTML='<label><input type="checkbox" data-express-v2-filter-input> <span>Express Delivery Only</span></label>';
  var toolbar=document.querySelector('.collection-toolbar');
  if(toolbar)toolbar.insertAdjacentElement('afterend',wrap);
  else main.prepend(wrap);
  var input=wrap.querySelector('input');input.checked=sessionStorage.getItem(FILTER)==='true';
  input.addEventListener('change',function(){sessionStorage.setItem(FILTER,String(input.checked));applyFilter();});
}
function applyFilter(){
  var input=document.querySelector('[data-express-v2-filter-input]');if(!input)return;
  var loc=readLocation();
  var verified=!!loc&&eligibleStores(loc).length>0&&tokenReady();
  input.disabled=!verified;
  input.title=verified?'Show items eligible for Express Delivery':'Select a delivery location and connect inventory to enable this filter';
  if(!verified&&input.checked){input.checked=false;sessionStorage.removeItem(FILTER);}
  document.querySelectorAll('[data-express-delivery-card-badge]').forEach(function(badge){
    var card=badge.closest('.collection-product-grid > li')||badge.closest('[data-product-card], .product-card');
    if(card)card.classList.toggle('express-v2-filtered',input.checked&&badge.dataset.deliveryState!=='available');
  });
}
async function refreshCards(seq){
  var badges=Array.from(document.querySelectorAll('[data-express-delivery-card-badge]'));
  if(!badges.length)return;
  injectFilter();syncMobileLauncher();
  var availableBadges=badges.filter(function(b){return b.dataset.variantAvailable==='true';});
  badges.forEach(function(b){if(b.dataset.variantAvailable!=='true')pill(b,'unavailable','');});
  if(!availableBadges.length){applyFilter();return;}
  var loc=readLocation();
  if(!tokenReady()){
    availableBadges.forEach(function(b){pill(b,'pending','Inventory setup pending');});
    applyFilter();return;
  }
  availableBadges.forEach(function(b){pill(b,'loading','Checking delivery…');});
  try{
    var ids=availableBadges.map(function(b){return b.dataset.variantId;}).filter(Boolean);
    var position=loc||{lat:25.0334958,lng:55.1862574};
    var inventory=await queryInventory(ids,position);if(seq!==inventorySeq)return;
    var stores=loc?eligibleStores(loc):[];
    var expressPromise=stores.length?promise():null;
    availableBadges.forEach(function(b){
      var variantId=b.dataset.variantId;
      var expressStore=stores.length?core.findStoreForVariant(variantId,1,inventory,stores):null;
      if(expressStore&&expressPromise){
        pill(b,'available',expressPromise.label);
      }else{
        var standard=standardFor(variantId,1,inventory,fallbackFromCard(b));
        pill(b,'standard',standardCardLabel(standard));
      }
    });
  }catch(error){
    console.error('Express Delivery V2: card availability check failed',error);
    availableBadges.forEach(function(b){pill(b,'standard','');});
  }
  applyFilter();
}
function bridge(detail){
  document.dispatchEvent(new CustomEvent('elc:express-delivery:result',{detail:detail}));
}
async function refreshPdpContext(context,seq){
  var id=context&&context.variantId;if(!id)return;
  if(context.available===false){
    bridge({variantId:id,state:'unavailable',title:'Delivery',message:'Currently unavailable',detail:'This variant is sold out.',badge:'Unavailable'});
    return;
  }
  var loc=readLocation();
  if(!tokenReady()){
    bridge({variantId:id,state:'standard',title:'Delivery',message:'Check estimated delivery at checkout.',detail:loc?'Deliver to: '+displayArea(loc):'Choose your delivery location.',badge:'',actionLabel:loc?'Change location':'Choose location'});
    return;
  }
  bridge({variantId:id,state:'loading',title:'Delivery',message:'Checking available stock and delivery timing…',detail:loc?'Deliver to: '+displayArea(loc):'',badge:''});
  try{
    var position=loc||{lat:25.0334958,lng:55.1862574};
    var inventory=await queryInventory([id],position);
    if(seq!==inventorySeq)return;
    var requestedQty=Number(document.querySelector('[data-product-page] [data-quantity-input]')?.value)||1;
    var stores=loc?eligibleStores(loc):[];
    var expressStore=stores.length?core.findStoreForVariant(id,requestedQty,inventory,stores):null;
    if(expressStore){
      var p=promise();
      var today=p.key==='today';
      var tomorrow=p.key==='tomorrow';
      var title=today?'⚡ Get it today':tomorrow?'⚡ Get it tomorrow':'⚡ '+p.label;
      var message=today?'Order before '+formatCutoff()+' for delivery today.':tomorrow?'Order now for delivery tomorrow.':'Expected delivery: '+formatDate(p.deliveryDate)+'.';
      bridge({variantId:id,state:today?'today':'tomorrow',title:title,message:message,detail:'Deliver to: '+displayArea(loc),badge:'',actionLabel:'Change location'});
    }else{
      emitStandard(id,inventory,loc,requestedQty);
    }
  }catch(error){
    console.error('Express Delivery V2: PDP stock check failed',error);
    bridge({variantId:id,state:'standard',title:'🚚 Estimated delivery',message:'Delivery estimate is temporarily unavailable. Confirm at checkout.',detail:loc?'Deliver to: '+displayArea(loc):'',badge:'',actionLabel:loc?'Change location':'Choose location'});
  }
}
function refreshAll(){
  var seq=++inventorySeq;refreshCards(seq);
  document.querySelectorAll('[data-express-delivery-slot]').forEach(function(row){
    var page=row.closest('[data-product-page]');var select=page&&page.querySelector('[data-variant-select]');if(!select)return;
    var option=select.selectedOptions&&select.selectedOptions[0];
    refreshPdpContext({variantId:select.value,available:option?option.dataset.available==='true':true},seq);
  });
  window.dispatchEvent(new CustomEvent('express-delivery:promise-refreshed'));
}
function init(){
  if(!readConfig())return;bindUi();injectFilter();syncMobileLauncher();
  document.addEventListener('elc:express-delivery:context',function(event){var seq=++inventorySeq;refreshPdpContext(event.detail||{},seq);});
  document.addEventListener('elc:express-delivery:action',open);
  document.addEventListener('express-v2:coordinate-selected',function(event){
    var d=event.detail||{};
    var lat=Number(d.lat),lng=Number(d.lng);
    if(!Number.isFinite(lat)||!Number.isFinite(lng))return;
    setPending({lat:lat,lng:lng,label:String(d.label||'Selected location'),area:String(d.area||'').trim(),source:String(d.source||'search')});
    status('Location selected. Check delivery availability.');
  });
  document.addEventListener('express-v2:search-cleared',function(){
    setPending(null);
  });
  window.addEventListener('express-delivery:location-updated',function(){updateLauncher();refreshAll();});
  window.addEventListener('resize',syncMobileLauncher);
  document.addEventListener('change',function(event){
    if(event.target&&event.target.matches&&event.target.matches('[data-quantity-input]'))refreshAll();
  });
  document.addEventListener('click',function(event){
    if(event.target&&event.target.closest&&event.target.closest('[data-quantity-plus],[data-quantity-minus]'))window.setTimeout(refreshAll,0);
  });
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden){refreshAll();schedulePromiseRefresh();}
  });
  schedulePromiseRefresh();
  document.addEventListener('shopify:section:load',function(){bindUi();refreshAll();});
  var observer=new MutationObserver(function(muts){
    var relevant=muts.some(function(m){return Array.from(m.addedNodes).some(function(n){return n.nodeType===1&&(n.matches&&n.matches('[data-product-card], .product-card')||n.querySelector&&n.querySelector('[data-product-card], .product-card'));});});
    if(relevant)setTimeout(function(){bindUi();refreshAll();},100);
  });
  observer.observe(document.body,{childList:true,subtree:true});
  refreshAll();
}
window.ELCExpressV2CartAPI=Object.freeze({readConfig:readConfig,readLocation:readLocation,eligibleStores:eligibleStores,queryInventory:queryInventory,standardFor:standardFor,getExpressPromise:promise,formatDate:formatDate});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();